module.exports = __webpack_public_path__ + "img/report.050f6f06.png";